import ErrorMessage from "../../../atoms/controls/validation/ErrorMessage";
import FloatingInput from "../../../atoms/controls/input/FloatingInput";
import FloatingLabel from "../../../atoms/controls/label/FloatingLabel";
import { useState } from "react";
import EyeToggleButton from "../../../atoms/buttons/EyeToggleButton";

const FloatingInputField = ({
  id,
  label,
  type = "text",
  placeholder = "",
  title = "",
  value,
  onChange,
  required,
  disabled,
  error,
  formikTouched,
  showDefaultValidation,
  ...props
}) => {
  const [visiblePassword, setVisiblePassword] = useState(false);
  return (
    <div className="relative">
      <FloatingInput
        id={id}
        type={
          type === "password" ? (visiblePassword ? "text" : "password") : "text"
        }
        placeholder={" "}
        value={value}
        onChange={onChange}
        required={required}
        disabled={disabled}
        title={title}
        error={error}
        touched={formikTouched}
        {...props}
      >
        <FloatingLabel htmlFor={id} labelText={label} />
        {type === "password" && (
          <EyeToggleButton
            onClick={setVisiblePassword}
            show={visiblePassword}
          />
        )}
      </FloatingInput>
      <ErrorMessage
        touched={formikTouched}
        errors={error}
        className={
          (type === "password") & !showDefaultValidation ? "hidden" : ""
        }
      />
    </div>
  );
};

export default FloatingInputField;
